const namespace = 'courseLiveOnline';

// 切换报名状态
export const CHANGE_SIGN_UP = "changeIsSignUp";
export const COMMIT_CHANGE_SIGN_UP = `${namespace}/${CHANGE_SIGN_UP}`;
